import { Input, Space, Collapse, Typography,Col ,Row } from 'antd'
import React from 'react'
import { Pie , Column } from '@ant-design/plots';
import { FontSizeOutlined } from '@ant-design/icons';

const { Panel } = Collapse;
const Title =Typography;
const PubPie = () => {
    const data = [
      {
        type: '2025',
        value: 1,
      },
      {
        type: '2024',
        value: 1,
      },
    ];
    const config = {
      appendPadding: 10,
      data,
      angleField: 'value',
      colorField: 'type',
      radius: 0.9,
      label: {
        type: 'outer',
        content: '{name} {percentage}',
      },
      interactions: [
        {
          type: 'pie-legend-active',
        },
        {
          type: 'element-active',
        },
      ],
    };
    return <Pie {...config} />;
  };

  const liStyle = {
    fontFamily: "Arial",
    margin:15

};

const pieChartHeight = '360px'; // Set your desired pie chart height

const SupportCellPublications = () => {
  return (
    <>
        
        <Title style={ {  textAlign: 'center', margin:'10px 0' }} ><h4>Aditya L1 Support Cell Publications</h4></Title>

              <div style={{ height: pieChartHeight }}>
              <PubPie />
              </div>

        <Collapse accordion defaultActiveKey={['2']} >
        <Panel header="2025" key="2">
            <ol>
            <li style={liStyle} ><a href="https://www.astron-soc.in/asi2025/abstract_details/ASI2025_605" target="_blank"> S. Bandyopadhyay and V. Pant, "Integral Adaptive Thresholding Inspired Solar Filament Detection," <i>43rd meeting of the Astronomical Society of India (ASI)</i>, 2025, vol. 43, Art. no. ASI2025_605.

                </a>
            </li>

            </ol>

        </Panel>           


        <Panel header="2024" key="1">
            <ol>
            <li style={liStyle} ><a href="https://www.ursi.org/proceedings/RCRS/2024/RCRS2024_0449.pdf" target="_blank"> S. Bandyopadhyay and V. Pant, "Solar Filaments Detection using Active Contours Without Edges," <i>2024 URSI Regional Conference on Radio Science ( URSI-RCRS)</i>, Bhimtal, India, 2024, pp. 1-4, doi:10.46620/URSI_RSRC24/0449KIA7088.

                </a>
            </li>

            </ol>

        </Panel>

    </Collapse>
    
    </>
  )
}

export default SupportCellPublications
